import { render, staticRenderFns } from "./tiered-video-task.vue?vue&type=template&id=fa3e40a4&scoped=true&lang=pug&"
import script from "./tiered-video-task.vue?vue&type=script&lang=js&"
export * from "./tiered-video-task.vue?vue&type=script&lang=js&"
import style0 from "./tiered-video-task.vue?vue&type=style&index=0&id=fa3e40a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3e40a4",
  null
  
)

export default component.exports